import { render, staticRenderFns } from "./SchoolQueueSlot.vue?vue&type=template&id=5f3ac6bd&"
import script from "./SchoolQueueSlot.vue?vue&type=script&lang=js&"
export * from "./SchoolQueueSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports